import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "./Header";
import Tooltip from "../../../Components/common/Tooltip/Tooltip";
import Spinner from "../../../Components/common/Spinner/Spinner";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";

import {
  RequestGetUrl2Settings,
  RequestSetUrl2Settings,
  RequestToggleUrl2Settings,
} from "../../../store/actions/mailGatewayActions";

const UrlRewriteForm = ({ selectedProduct, selectedHost }) => {
  const dispatch = useDispatch();

  const [settings, setSettings] = useState({
    url_rewrite: "",
    url_rewrite_target: "",
    url_rewrite_auto: "",
    url_rewrite_all: "",
    unattended_rewrite: "",
    phishbox_control:""
  });

  const urlSettings = useSelector((state) => state.mailGateway.url2Settings);
  const urlSettingsLoading = useSelector((state) => state.mailGateway.url2SettingsLoading);
  const setUrlSettingsLoading = useSelector((state) => state.mailGateway.setUrl2SettingsLoading);

  const urlSettingsStatus = urlSettings.url_rewrite === "1";

  useEffect(() => {
    dispatch(RequestGetUrl2Settings(selectedHost));
  }, [dispatch, selectedHost]);

  useEffect(() => {
    if (urlSettings && selectedHost) {
      setSettings((prevSettings) => ({
        ...prevSettings,
        ...urlSettings,
      }));
    }
  }, [urlSettings, selectedHost]);

  const toggleUrl2SettingsHandler = () => {
    if (urlSettingsLoading) return;
    dispatch(
      RequestToggleUrl2Settings({
        host: selectedHost,
        url_rewrite: urlSettingsStatus ? "0" : "1",
      }),
    );
  };

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const checkSaveButtonDisabled = () => {
    const keys = Object.keys(settings);
    for (const key of keys) {
      if (key === "url_rewrite") continue;
      else if (settings[key] !== urlSettings[key]) return false;
    }
    return true;
  };

  const saveHandler = () => {
    if (urlSettingsLoading || setUrlSettingsLoading) return;

    const { url_rewrite, ...subOptions } = settings;
    dispatch(RequestSetUrl2Settings({ host: selectedHost, reqBody: subOptions }));
  };

  return (
    <>
      <Header
        selectedProduct={selectedProduct}
        selectedHost={selectedHost}
        toggleProps={{
          show: true,
          text: "Status",
          active: urlSettingsStatus,
          onClick: toggleUrl2SettingsHandler,
        }}
      />
      <form className="products-body-form">
        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Unattended Url Control
              <Tooltip text="If enabled, url(s) will be written securely to make unattended control." showFlowGrow={true} />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="unattended_rewrite"
                  checked={settings.unattended_rewrite === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="unattended_rewrite"
                  checked={settings.unattended_rewrite === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>
        <div className="products-body-form__line"> 
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Backend System of Url Rewrite 
              <Tooltip text="Decide Host of the Rewritten URLs in the emails" showFlowGrow={true} />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="url_rewrite_target"
                  checked={settings.url_rewrite_target === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Ptest.cyber-fortress.com</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="url_rewrite_target"
                  checked={settings.url_rewrite_target === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Local Backend</p>
              </label>
            </div>
          </div>
        </div>
        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Url Rewrite Auto Redirect
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="url_rewrite_auto"
                  checked={settings.url_rewrite_auto === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="url_rewrite_auto"
                  checked={settings.url_rewrite_auto === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>

        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Url Rewrite for All Links
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="url_rewrite_all"
                  checked={settings.url_rewrite_all === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="url_rewrite_all"
                  checked={settings.url_rewrite_all === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>
        <div className="products-body-form__line">
          <div className="mailing__content__security m-b-20">
            <p className="light m-b-10 mailing__content__security__header">
              Auto Phisbox Analysis
              <Tooltip text="If enabled, system will do phishbox analyis on urls automatically" showFlowGrow={true} />
            </p>
            <div className="mailing__content__security__labels">
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="1"
                  name="phishbox_control"
                  checked={settings.phishbox_control === "1"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Enabled</p>
              </label>
              <label className="align-items">
                <input
                  className="mailing__content__security__input"
                  type="radio"
                  value="0"
                  name="phishbox_control"
                  checked={settings.phishbox_control === "0"}
                  onChange={inputChangeHandler}
                />
                <p className="margin-left-12">Disabled</p>
              </label>
            </div>
          </div>
        </div>

        <button
          type="button"
          className="save-button primary-button"
          onClick={saveHandler}
          disabled={checkSaveButtonDisabled()}>
          {urlSettingsLoading || setUrlSettingsLoading ? (
            <Spinner width={12} height={12} />
          ) : (
            "Save Settings"
          )}
        </button>

        <Backdrop
          spinner={false}
          absolute
          show={!urlSettingsStatus}
          message="Url Rewrite settings are inactive! Please click on the status button at the header to activate url rw settings."
          messageStyle={{ paddingTop: 0 }}
        />
      </form>
    </>
  );
};

export default UrlRewriteForm;
